<div class="cart-table-container">
  <div class="container-header">
    ORDER HISTORY
  </div>
  <table mat-table [dataSource]="cartTable">
    <ng-container matColumnDef="id">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>
        ORDER ID
      </th>
      <td mat-cell *matCellDef="let line">
        <div  class="id-text cell-content">{{ line.id }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>TRANSACTION TYPE</th>
      <td mat-cell *matCellDef="let line">
        <equine-ui-nx-cart-status [status]="line.type"></equine-ui-nx-cart-status>
      </td>
    </ng-container>

    <ng-container matColumnDef="authStatus">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>STATUS</th>
      <td mat-cell *matCellDef="let line">
        <equine-ui-nx-cart-status [status]="line.authStatus"></equine-ui-nx-cart-status>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>STATUS</th>
      <td mat-cell *matCellDef="let line">
        <equine-ui-nx-cart-status [status]="line.status"></equine-ui-nx-cart-status>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>DATE</th>
      <td class="cell-content" mat-cell *matCellDef="let line"> {{ line.date | timestamp | date:'medium' }}</td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>TOTAL<th>
      <td class="cell-content" mat-cell *matCellDef="let line">{{ line.total | amount | currency }} ({{ line.itemsCount }} items)</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th class="header-bg" mat-header-cell *matHeaderCellDef>Details<th>
      <td mat-cell *matCellDef="let line">
        @if(line.status === 'OPEN') {
          <button mat-button (click)="goToCart()" color="primary" class="btn-details">
            Go to cart
            <mat-icon iconPositionEnd>shopping_cart</mat-icon>
          </button>
        }
        @else {
          <button mat-button (click)="openDetailsDialog(line.id)" color="primary" class="btn-details">
            Transaction Details
            <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [length]="totalLines"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPaginationChange($event)"
    showFirstLastButtons
    aria-label="Select page of orders"
  >
  </mat-paginator>
</div>
